// extracted by mini-css-extract-plugin
export default {"container":"MessageSuggestions_container__YSAMv","rightSide":"MessageSuggestions_rightSide__2ifBh"};